import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { environmentDev } from '../../../../environments/environment.dev';
import { RaitingSystem } from '../ratings/raiting-system';
import { AllStatus } from '../../../core/services/status/all-status';
import { IHistoryLevel } from '../../model/i-history-level';
import { PlayersService } from '../players/players';

export type indexType = "first" | "second" | "third" | "fourth" | "fifth" | "sixth" | "seventh" | "" ;
export interface IViewLevel{
    rqId: number,
    levelNow: number,
    result:{
      points: number,
      maxPoints: number,
      level: number
    }
}


@Injectable({
  providedIn: 'root'
})

export class DifficultyLevel {

  temporaryCard: any;
  indx: indexType;
  // lastIndx: indexType;
  private lvl: number = 0;
  isTransition: boolean;
  private playerId: number;
  private player: any;

  players = inject(PlayersService);

  difficultyLevels: WritableSignal<any> = signal(environmentDev.difficultyLevelsEmpty);
  raiting = inject(RaitingSystem);
  status = inject(AllStatus);

  initWork(card: any){
    this.temporaryCard = card;
    this.indexLevel(card.level);
    this.changeDifficultyArray();
   
  }

  isNewLevel(level: number, type_id: number, player_id: number){
    this.isTransition = false;
    this.playerId = player_id;
    this.findPlayer();
    this.lvl = level;
    if(level > 1){
      this.indexLevel(level-1);
      this.isDataLevel(level-1);
    }
    this.indexLevel(level);
    this.isViewWindow(type_id);
  }

  private findPlayer(){
    this.player = this.players.players.find((pl:any)=> pl.player_id === this.playerId);
  }

  indexLevel(level: number){
    switch(level){
      case 1: this.indx = 'first'; break;
      case 2: this.indx = 'second'; break;
      case 3: this.indx = 'third'; break;
      case 4: this.indx = 'fourth'; break;
      case 5: this.indx = 'fifth'; break;
      case 6: this.indx = 'sixth'; break;
      case 7: this.indx = 'seventh'; break;
      default: console.info('Not level');break;
    }
  }

  
  // суть ідея даного метода 
  // 1) Попап про новий рівень
  // 2) Очистка старих даних попапу
  // 3) Збір даних: points, maxPoints, level
  // 4) Відображення рукостискання
  isViewWindow(field: number){
    let copy = structuredClone(this.difficultyLevels());
    if( copy[this.indx].isViewPopap && this.isTransition ){
      copy[this.indx].isViewPopap = false;
      this.status.clearDataDifficulty();      
      const data: IViewLevel = { 
        rqId: this.player.rq_id,
        levelNow: this.lvl,
        result: this.valuePreviousLevel()
      }          
      this.status.setDataDifficulty(data);
      this.status.setDifficultyWindow(true);
      this.showInfoWithFooter();
      
      // змінюємо значення та перезаписуємо difficultyLevels      
      this.difficultyLevels.set(copy);
    }
 
  }

  private showInfoWithFooter(){
    this.status.setOpenFooter(true);
  }

  private isDataLevel(level: number){
    let copy = structuredClone(this.difficultyLevels());
    if(copy[this.indx].maxPoints > 0){
      this.isTransition = true;
    }
    if(level > 1 && !this.isTransition){
      this.indexLevel(level-1);
      this.isDataLevel(level-1);
    }
  }

  private valuePreviousLevel(){
    this.isTransition = false;
    this.indexLevel(this.lvl-1);
    this.isDataLevel(this.lvl-1);

    let pnts: number = 0, mxPnts: number = 0, level: number = 0;
    if(this.isTransition){
      let copy = structuredClone(this.difficultyLevels());
      pnts = copy[this.indx].points;
      mxPnts = copy[this.indx].maxPoints;
      level = copy[this.indx].history[0].level;
    }
    return {points: pnts, maxPoints: mxPnts, level: level }
  }

  private changeDifficultyArray(){
    let newField: number = 0;
    if(!this.difficultyLevels()[this.indx].fields.includes(this.temporaryCard.type_id)){
      newField = this.temporaryCard.type_id;
    }
    let result = this.raiting.successesInGame(this.temporaryCard);

    this.updateDifficulty(result.points, result.maxPoints, newField);
    
  }

  private updateDifficulty(points: number, maxPoints: number, field: number = 0){
    
    let forHistory: IHistoryLevel;
    let copy = structuredClone(this.difficultyLevels());   
    if(field !== 0){
      copy[this.indx].fields.push(field);
      forHistory = {
        field: field,
        points: points,
        maxPoints: maxPoints,
        level: this.lvl
      };
      copy[this.indx].history.push(forHistory);
      
    } else {
      copy[this.indx].history.forEach((item: IHistoryLevel) =>{
        if(item.field === this.temporaryCard.type_id){
          item.points += points;
          item.maxPoints += maxPoints;
        }
      });
    }

    let p: number = 0,mp : number = 0;
    copy[this.indx].history.forEach((item: IHistoryLevel) =>{
      p = p + item.points;
      mp = mp + item.maxPoints;
    });

    copy[this.indx].points = p;
    copy[this.indx].maxPoints = mp;

    this.difficultyLevels.set(copy);   
  }

  clear(){
    this.difficultyLevels.set(environmentDev.difficultyLevelsEmpty);
  }

  countLevel(): number{
    let count: number = 0;
    let copy = structuredClone(this.difficultyLevels());
    if(copy.first.history.length){ count = count + 1; this.indx = 'first';}
    if(copy.second.history.length){ count = count + 1; this.indx = 'second';}
    if(copy.third.history.length){ count = count + 1; this.indx = 'third';}
    if(copy.fourth.history.length){ count = count + 1; this.indx = 'fourth';}
    if(copy.fifth.history.length){ count = count + 1; this.indx = 'fifth';}
    if(copy.sixth.history.length){ count = count + 1; this.indx = 'sixth';}
    if(copy.seventh.history.length){ count = count + 1; this.indx = 'seventh';}
   
    return count;
  }

}
